import getReachablePath from '../../utils/getReachablePath/index.js';
import { AttackType } from '@wareena/grid-battles-entity/game/codebook/attackTypes';
import { getTerrainPreferencesForAttack } from '../../utils/terrainPreferences.js';
export const doesMeleeUnitPoseAThreat = function doesMeleeUnitPoseAThreat({ enemyUnit, unitInPossibleDanger, hexProperties, rules, allUnits, mapHexes, }) {
    const reachablePath = getReachablePath(enemyUnit, unitInPossibleDanger, hexProperties, rules, allUnits, mapHexes, getTerrainPreferencesForAttack());
    if (!reachablePath) {
        return false;
    }
    return true;
};
export const doesRangedUnitPoseAThreat = function doesRangedUnitPoseAThreat({ enemyUnit, unitInPossibleDanger, hexProperties, rules, allUnits, }) {
    if (hexProperties.getDistance(enemyUnit.position, unitInPossibleDanger.position) >
        enemyUnit.range) {
        return false;
    }
    if (!rules.isLosUnobstructed(enemyUnit.position, unitInPossibleDanger.position, allUnits)) {
        return false;
    }
    return true;
};
const attackTypeToThreatDeterminatorMap = {
    [AttackType.Melee]: doesMeleeUnitPoseAThreat,
    [AttackType.Ranged]: doesRangedUnitPoseAThreat,
};
function doesEnemyPoseAThreat({ enemyUnit, unitInPossibleDanger, hexProperties, rules, allUnits, mapHexes, }) {
    const threatDeterminator = attackTypeToThreatDeterminatorMap[enemyUnit.attackType];
    if (threatDeterminator) {
        return threatDeterminator({
            enemyUnit,
            unitInPossibleDanger,
            hexProperties,
            rules,
            allUnits,
            mapHexes,
        });
    }
    return false;
}
export default doesEnemyPoseAThreat;
